import { SyntheticEvent } from "react";
import handleTouch from "../../../../../common/helpers/handleTouch";
import { IBar, IScoreEditorThis } from "../../../../../common/types";

export const handleToggleRest = async function (this: IScoreEditorThis, e: KeyboardEvent | MouseEvent | TouchEvent) {
  if (!(await handleTouch(e))) return;
  const { selectedNote, activeVoice } = this.state;
  if (selectedNote?.lyric) return;
  const score = { ...this.state.score };
  const bars = score["bars" + (activeVoice || "")] as IBar[];
  if (selectedNote && bars[selectedNote.bar]?.notes?.[selectedNote.note]) {
      const note = bars[selectedNote.bar].notes[selectedNote.note];
      if (note.r) {
          delete note.r;
      } else {
          note.r = 1;
          delete note.p;
      }
      this.setState({ score, restMode: !this.state.restMode });
  } else {
      this.setState({ restMode: !this.state.restMode });
  }
};
